import { Navigate, Outlet } from 'react-router';
import { useAuthContext } from '@/contexts/auth-context';

export function ProtectedRoute() {
  const { user, isAuthenticated, isLoading } = useAuthContext();

  if (isLoading) {
    return (
      <div className="flex min-h-screen items-center justify-center">
        <div className="h-8 w-8 animate-spin rounded-full border-4 border-primary border-t-transparent" />
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  if (user && user.role !== 'teacher' && user.role !== 'admin') {
    return (
      <div className="flex min-h-screen flex-col items-center justify-center gap-4">
        <h1 className="text-2xl font-bold">Access Denied</h1>
        <p className="text-muted-foreground">
          This dashboard is only available for teachers and admins.
        </p>
      </div>
    );
  }

  return <Outlet />;
}
